/** @format */

export class GbRootController {
    constructor($galabidUrl) {
        'ngInject';

        this.$galabidUrl = $galabidUrl;
    }
}
